import { Mob } from "../mob";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { DummyMobCorpse } from "./dummyMobCorpse";

/**
 * Second inert mob variant. Identical behavior to {@link DummyMob} (never acts,
 * leaves a DummyMobCorpse) — exists as a distinct registered entity so tests and
 * the playground can place two different dummy targets. Not spawned in normal gameplay.
 */
export class DummyMobB extends Mob {
	static key = "DummyMobB";

	constructor(xy: XY) {
		super(xy);
	}

	processMobAction(): void {}

	generateCorpse(): PhysicalThing | null {
		return new DummyMobCorpse(this.xy);
	}

	static deserialize(data: any): DummyMobB {
		const mob = new DummyMobB(deserializeXY(data.xy));
		mob.restoreMobFields(data);
		return mob;
	}
}
